// extracted by mini-css-extract-plugin
export default {"root":"ConvertedAmount_root__Ulg7T"};